import { css } from 'linaria';
import { createAdaptiveComponent } from './create-adaptive-component';

const fromDesktop = css`
  display: none;

  @media (--from-desktop) {
    display: contents;
  }
`;

export const FromDesktop = createAdaptiveComponent({
  displayName: 'FromDesktop',
  ssrClassName: fromDesktop,
});
